<template>
  <div class="haacf">
    <!-- banner -->
    <div class="banner">
      <div id="slideBox" class="slideBox">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="item in banner" :key="item.id"><img :src="item" /></swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!-- 报名入口 专家评委入口 管理入口 -->
    <div class="tabBox" :style="{ 'margin-top': banner.length == 0 ? '40px' : '' }">
      <!-- :class="index == tabIndex ? 'tabItemChack':'tabItem'" -->
      <!-- :style="{'font-size':'44px','color': index == tabIndex ? '#fff':'#4F90FD'}" -->
      <!-- :style="{'font-size':'40px','color': index == tabIndex ? '#fff':'#4F90FD'}" -->
      <div v-for="(item, index) in tabList" :key="index" @click="getTab(index, item)" class="tabItem">
        <i :class="item.icon" style="font-size: 44px;"></i>
        <div class="tabItemText">{{ item.name }}</div>
      </div>
      <div></div>
      <div></div>
    </div>
    <!-- 赛事通知 -->
    <div class="homehot">
      <div class="title">赛事通知</div>
      <div class="mall" @click="gotoNotice">
        更多
        <li class="el-icon-arrow-right"></li>
      </div>
      <el-carousel :autoplay="false" arrow="never" trigger="click" style="height: 520px;margin-bottom:60px">
        <el-carousel-item v-for="(item, inter) in newsDataListCarousel" :key="inter" style="height: 490px;">
          <div class="sstzbox">
            <div v-for="(i, index) in item.content" :key="index" class="carItem" @click="getMatchList(index, i.id)">
              <img :src="i.img" />
              <div class="rightbody">
                <div :class="'title'">{{ i.title }}</div>
                <div :class="'time'">{{ i.issueTime }}</div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 大赛流程 -->
    <div class="flowBox">
      <div class="flowTitle">
        大赛流程
      </div>
      <flow :progressList="progressList" :show="flowShow"></flow>
    </div>

    <!--  赛事相关  -->
    <div class="comp_related" id="download">
      <div class="title">赛事相关</div>
      <div class="content">
        <img src="../assets/onTheLeft.png" class="imgbg">
        <div class="contentLeft">
          <div v-for="(item, index) in matchAboutList" :key="index" @click="getMatchAbout(index, item)"
            :class="matchAboutIndex == index ? 'item itemChack' : 'item nocheckitemryj'">
            <img :src="item.icon" alt="">
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="contentRight" v-if="matchAboutContent == '资料下载'">
          <a v-for="i in objnews" :key="i.uid" @click="downName(i.url, i.name)" style="cursor: pointer;display: block;">{{ i.name
            }}</a>
        </div>
        <div class="contentRight" v-else v-html="matchAboutContent"></div>
        <img src="../assets/onTheRight.png" class="imgbg">
      </div>
    </div>
    <!-- 专家咨询 -->
    <!-- <div class="expertBox">
      <div class="title">专家咨询</div>
      <div class="mall">
        更多
        <li class="el-icon-arrow-right"></li>
      </div>
      <div style="display: flex;justify-content: center;">
        <div class="expertContent">
          <div v-for="(item,index) in expertList" :key="index" class="itemBox">
            <div class="item" :style="{'background-image':'url('+item.img+')','background-size': 'cover'}" >
              <div class="board" @mouseenter="item.boardShow = true" @mouseleave="item.boardShow = false">
                <div class="text1" style="margin-bottom:15px">{{item.name}}</div>
                <div class="text2">{{item.title}}</div>
                <div class="text3" v-if="item.boardShow" style="margin: 30px 0 20px;">{{item.field}}</div>
                <div class="text3" v-if="item.boardShow">{{item.introduce}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 优秀作品展示 -->
    <div class="carMach" v-if="machList.length != 0">
      <div class="title">优秀作品展示</div>
      <div class="carBoxMach">
        <div v-for="(item, index) in machList" :key="index" class="carBoxMachItem" @click="gotoWork(item)">
          <img :src="item.coverImage" alt="">
          <div style="padding: 20px;">
            <div style="margin-bottom:20px">{{ item.itemName }}</div>
            <div>{{ item.schoolName }}</div>
          </div>
        </div>
      </div>
      <div class="more" @click="gotoMachList">
        更多
        <li class="el-icon-arrow-right"></li>
      </div>
    </div>
    <!-- 参赛学校 -->
    <div class="ParticipatingSchools" v-show="params.domain != 'lzpcc' && params.domain != 'gszjbs'">
      <div class="title">参赛学校</div>
      <el-carousel :autoplay="false" arrow="never" trigger="click" class="carouselheight"
        :style="{ '--width': 1000 / schoollogoImgCarousel.length + 'px' }">
        <el-carousel-item v-for="(item, inder) in schoollogoImgCarousel" :key="inder" class="carouselheight">
          <div class="carBoxSchool">
            <div v-for="(i, index) in item.content" :key="index" class="carBoxSchoolItem">
              <img :src="i" class="img" />
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 赛事锦囊 -->
    <div style="width: 900px; margin: auto" class="sadadfc" v-if="videoList.length > 0">
      <div class="titleasdas">赛事锦囊</div>
      <el-carousel :interval="0" type="card" height="312px" indicator-position="none" @change="vidPP" class="pc">
        <el-carousel-item v-for="(item, index) in videoList" :key="index" @change="vidPP">
          <video :src="item.url" controls></video>
          <h2>{{ item.name }}</h2>
        </el-carousel-item>
      </el-carousel>
      <div class="banner pcmobile">
        <div id="slideBox" class="slideBox" style="height: 42.7vh;">
          <swiper :options="swiperOption" ref="mySwiper" style="height: 42.7vh;">
            <swiper-slide v-for="(item, index) in videoList" :key="index">
              <video :src="item.url" controls></video>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  //加密
  import {
    getTokenUrl
  } from "@/api/uploading";
  // 引入插件
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import {
    getHomeData,
    getSchoolData,
    getTimerShaft,
    getTimer,
    getMatchVideo,
    downName,
    getDistinctionItemByMatchId
  } from "../api/home";
  import {
    getDomain,
    isDuringDate,
    getFormal
  } from "@/utils/toos";
  import {
    Session
  } from "@/utils/storage";
  import {
    getData
  } from "@/api/notice";
  import BScroll from "better-scroll";
  import eventBus from '../views/user/eventBus';
  import flow from './flow.vue'
  export default {
    components: {
      swiper,
      swiperSlide,
      flow
    },
    data() {
      return {
        dataList: {},
        banner: [],
        swiperOption: {
          circular: true,
          // notNextTick:true,
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },

          // 显示分页
          pagination: {
            el: ".swiper-pagination",
            clickable: true, //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
        params: {
          domain: "",
          //   id:14
        },
        competingKits: {
          loop: true,
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          // 显示分页
          pagination: {
            el: ".swiper-pagination1",
            clickable: true, //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          slidesPerView: 3, //一行显示3个
          slidesPerColumn: 2, //显示2行
        },
        matchId: "",
        showSelf: "",
        clickIndex: null,
        objnews: [],
        newsparams: {
          page: 1,
          limit: 4,
          matchId: "",
          orderRule: "create_time",
        },
        newsDataList: [],
        schoollogoImg: [],
        imgUrl: "http://wlzj2.test.upcdn.net",
        timerShaft: [],
        dialogVisible: false,
        schooltop: false,
        systime: "",
        timeactive: null,
        video: "",
        videoList: [],
        myurl: "https://wlzj-platform.posedu.com.cn/manage/uploads/20211031/lmnhax420018fngepwkubpv3jwbg7nx8.jpg",
        tabList: [{
            icon: 'el-icon-s-order',
            name: '报名入口',
            path: '/login'
          },
          {
            icon: 'el-icon-user-solid',
            name: '专家评委入口',
            path: ''
          },
          {
            icon: 'el-icon-menu',
            name: '管理入口',
            path: ''
          },
        ],
        tabIndex: 0,
        matchIndex: 0,
        progressList: [],
        matchAboutList: [{
            name: '大赛组委会',
            icon: require('../assets/optionIcon.png')
          },
          {
            name: '专家委员会',
            icon: require('../assets/optionIcon1.png')
          },
          {
            name: '大赛组委会联系方式',
            icon: require('../assets/optionIcon2.png')
          },
          {
            name: '参赛对象',
            icon: require('../assets/optionIcon3.png')
          },
          {
            name: '资料下载',
            icon: require('../assets/optionIcon4.png')
          },
          {
            name: '奖项设置',
            icon: require('../assets/optionIcon5.png')
          }
        ],
        matchAboutContent: '',
        matchAboutIndex: 0,
        machList: [],
        schoollogoImgCarousel: [],
        newsDataListCarousel: [],
        flowShow: false,
        expertList: [{
            boardShow: false,
            name: '周丽佳',
            title: '教授',
            field: '作品打磨、作品指导、比赛讲解',
            introduce: '专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍',
            img: 'https://img0.baidu.com/it/u=1198142678,2495936425&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
          },
          {
            boardShow: false,
            name: '周丽佳',
            title: '教授',
            field: '作品打磨、作品指导、比赛讲解',
            introduce: '专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍',
            img: 'https://img0.baidu.com/it/u=1198142678,2495936425&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
          },
          {
            boardShow: false,
            name: '周丽佳',
            title: '教授',
            field: '作品打磨、作品指导、比赛讲解',
            introduce: '专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍',
            img: 'https://img0.baidu.com/it/u=1198142678,2495936425&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
          },
          {
            boardShow: false,
            name: '周丽佳',
            title: '教授',
            field: '作品打磨、作品指导、比赛讲解',
            introduce: '专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍',
            img: 'https://img0.baidu.com/it/u=1198142678,2495936425&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
          },
          {
            boardShow: false,
            name: '周丽佳',
            title: '教授',
            field: '作品打磨、作品指导、比赛讲解',
            introduce: '专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍专家介绍',
            img: 'https://img0.baidu.com/it/u=1198142678,2495936425&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500'
          },
        ]
      };
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      }
    },
    created() {
      //   this.$store.dispatch("setProcess", 100);
      //   console.log('vuex1111111111111',this.$store);
      getDomain();

      this.params.domain = Session.get("domain");
      getHomeData(this.params).then((res) => {
        if (!this.params.domain || res.data.data == null) {
          this.$router.push("/nomatch");
        }
        if (!res.data.data) {
          console.log("获取数据失败");
          return;
        }
        this.newsparams.matchId = res.data.data.id;
        console.log("window.location.origin", window.location.origin);
        if (this.newsparams.matchId == 247) {
          this.tabList = [
          // {
          //     icon: 'el-icon-user-solid',
          //     name: '选手抽签',
          //     path: '/draw'
          //   },
            // {
            //   icon: 'el-icon-s-custom',
            //   name: '汇总表上传',
            //   path: '/login?type=organizationalAward'
            // },
            {
              icon: 'el-icon-s-order',
              name: '报名入口',
              path: '/login'
            },
            {
              icon: 'el-icon-user-solid',
              name: '专家评委入口',
              path: ''
            },
            {
              icon: 'el-icon-menu',
              name: '管理入口',
              path: ''
            },
          ]
          this.tabList[1].path = window.location.origin + '/mms/#/login'
          this.tabList[2].path = window.location.origin + '/mms/#/login'
        } else {
          this.tabList = [
            {
              icon: 'el-icon-s-order',
              name: '报名入口',
              path: '/login'
            },
            {
              icon: 'el-icon-user-solid',
              name: '专家评委入口',
              path: ''
            },
            {
              icon: 'el-icon-menu',
              name: '管理入口',
              path: ''
            },
          ]
          this.tabList[1].path = window.location.origin + '/mms/#/login'
          this.tabList[2].path = window.location.origin + '/mms/#/login'
        }

        getData(this.newsparams).then((res) => {
          this.newsDataList = res.data.data.list;
          getTimerShaft({
            matchId: this.newsparams.matchId
          }).then((res) => {
            //   console.log("赛段进程",res)
            this.timerShaft = res.data.data;
            this.progressList = res.data.data
            this.progressList.forEach(element => {
              element.startTime = element.matchTime.split(',')[0]
              element.endTime = element.matchTime.split(',')[1]
              if (element.intro != '') {
                this.flowShow = true
              }
            });
            this.timerShaft.forEach((item) => {
              item.matchTime = item.matchTime.replace(",", "至");
            });
            let arr = [];
            res.data.data.forEach((item) => {
              arr.push(item.matchTime.split(","));
            });
            arr.forEach((item, index) => {
              if (isDuringDate(this.systime, item[0], item[1])) {
                this.timeactive = index;
              }
            });
          });
          this.carousel('newsDataListCarousel', this.newsDataList, 6)
        });

        // 存储 domain 到浏览器缓存
        // this.matchLogo =res.data.data.matchLogo
        // this.matchName =res.data.data.matchName
        // document.title = res.data.data.matchName
        Session.set("matchID", this.matchId);
        getMatchVideo({
          matchId: this.newsparams.matchId
        }).then((res) => {
          if (!res.data.data || res.data.data.length < 1) {
            return false;
          }
          var url = res.data.data[0].url;
          if (!url) {
            return false;
          }
          this.videoList = JSON.parse();
          this.videoList.forEach((item) => {
            item.name = item.name.replace(".mp4", "");
          });
        });
        //   Session.set('matchLogo',this.matchLogo)
      });

      //  this.getListData()
    },
    watch: {
      $route(v, o) {
        if (v.fullPath == "/home?mao=1") {
          this.getMatchAbout(4, {
            name: '资料下载'
          })
          setTimeout(() => {
            this.$router.push({
              path: "/home"
            })
          }, 100);
        }
      }
    },
    mounted() {
      getTimer().then((res) => {
        this.systime = res.data.data;
      });
      this.getListData();
      this.newsparams.matchId = Session.get("matchID");

      //  this.showSelf =  Session.get('token')
      //  console.log(this.showSelf)
      // current swiper instance
      // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了

      // this.swiper.slideTo(3, 1000, false);
      if (this.$route.query.mao == 1) {
        let selector = "#download";
        setTimeout(() => {
          this.getMatchAbout(4, {
            name: '资料下载'
          })
          this.$router.push({
            path: "/home"
          })
        }, 100);
        var anchor = this.$el.querySelector(selector); // 参数为要跳转到的元素id,是(#id)
        document.body.scrollTop = anchor.offsetTop; // chrome
        document.documentElement.scrollTop = anchor.offsetTop; // firefox
      }
      this.getDistinctionItem()
      console.log("this.$route.query", this.$route.query);
      if (this.$route.query.type == 'studentRegistration') {
        this.$router.push({
          path: '/login'
        })
      }
    },
    methods: {
      getListData() {
        let domain = Session.get("domain");
        let matchID = Session.get("matchID");
        this.params.domain = domain;
        getHomeData(this.params).then((res) => {
            if (res.data.data == null) {
              this.$router.push("/nomatch");
            }
            this.matchId = res.data.data.id;
            // 存储 domain 到浏览器缓存
            Session.set("matchID", this.matchId);
            Session.set("ifStudent", res.data.data.ifStudent);
            Session.set("ifHasItem", res.data.data.ifHasItem);

            this.dataList = res.data.data;
            let objbanner = [];
            if (this.dataList.banner) {
              objbanner = JSON.parse(this.dataList.banner);
            }
            let objnews = [];
            if (this.dataList.attachment) {
              objnews = JSON.parse(this.dataList.attachment);
            }
            let newbanner = [];
            if (objbanner) {
              objbanner.forEach((item) => newbanner.push(item.url));
              var b = 0;
              var lastbanner = [];
              for (var a = 0; a < newbanner.length; a++) {
                getTokenUrl(newbanner[a]).then((res) => {
                  lastbanner[b] = res.data;
                  b++
                });
              }
            }
            this.objnews = objnews;
            this.banner = lastbanner;
            if (!this.dataList.showVideo) {
              return false;
            }
            if (JSON.parse(this.dataList.showVideo).length > 0) {
              var lastvideo = "";
              lastvideo = JSON.parse(this.dataList.showVideo)[0].url;
              getTokenUrl(lastvideo).then((res) => {
                this.video = res.data;
              });

            }
            this.matchAboutContent = this.dataList.committee

            //   console.log("objnews",this.objnews)
          }),
          //   getTimerShaft({matchId:matchID}).then(res=>{
          //     //   console.log("赛段进程",res)
          //       this.timerShaft = res.data.data
          //       let arr = []
          //       res.data.data.forEach(item =>{
          //           arr.push(item.matchTime.split(","))
          //       })
          //       console.log("matvhtime",arr);
          //       arr.forEach((item,index) =>{
          //           console.log("item[0]",item[0],item[1]);
          //          if(isDuringDate(this.systime,item[0],item[1])){
          //              console.log("itwmindex",index);
          //              this.timeactive = index
          //          }
          //       })
          //   })
          getSchoolData({
            domain: domain
          }).then((res) => {
            let schoolImg = res.data.data;
            if (!schoolImg) {
              return;
            }
            schoolImg.forEach((item) => {
              if (item.logo && item.logo.search("http") == -1) {
                let imgurl = this.imgUrl + item.logo;
                this.schoollogoImg.push(imgurl);
              } else if (item.logo) {
                this.schoollogoImg.push(item.logo);
              }
            });
            this.carousel('schoollogoImgCarousel', this.schoollogoImg, 40)
          });
      },
      toinfo(e) {
        this.$router.push({
          path: "/noticInfo",
          query: {
            id: e
          }
        });
      },
      showShaft(e) {
        this.dialogVisible = true;
      },
      scrollFunc(e) {
        let scroll = document.documentElement.scrollTop;
      },
      getMatchId() {
        getDomain();
        getHomeData({
          domian: Session.get("domain")
        }).then((res) => {
          if (!this.params.domain || res.data.data == null) {
            this.$router.push("/nomatch");
          }
          this.matchId = res.data.data.id;
          // 存储 domain 到浏览器缓存
          this.matchLogo = res.data.data.matchLogo;
          this.matchName = res.data.data.matchName;
          document.title = res.data.data.matchName;
          Session.set("matchID", this.matchId);
          Session.set("matchLogo", this.matchLogo);

          getData(this.newsparams).then((res) => {
            this.newsDataList = res.data.data.list;
          });
        });
      },
      chooseClick(e) {
        if (this.clickIndex == e) {
          this.clickIndex = null;
        } else {
          this.clickIndex = e;
        }
      },
      vidPP() {
        var videos = document.getElementsByTagName("video"); //获取所有video
        for (var j = videos.length - 1; j >= 0; j--) {
          videos[j].pause();
        }
      },
      downName(filePath, fileName) {
        // console.log(`https://api.match.posedu.com.cn/support/download/download?filePath=${filePath}&fileName=${encodeURI(fileName)}`);
        window.open(
          `${getFormal()}/support/download/downloadencoder?filePath=${filePath}&fileName=${fileName}`
        );
      },
      getTab(index, item) {
        this.tabIndex = index
        if (this.newsparams.matchId == 247 ? index > 0 : index > 0) {
          window.location.href = item.path
          eventBus.$emit('loginSuccess', '');
        } else {
          this.$router.push({
            path: item.path
          })
        }


      },
      getMatchList(index, e) {
        this.matchIndex = index
        this.$router.push({
          path: "/noticInfo",
          query: {
            id: e
          }
        });
      },
      gotoNotice() {
        this.$router.push({
          path: "/notice"
        });
      },
      getMatchAbout(index, item) {
        this.matchAboutIndex = index
        switch (item.name) {
          case '大赛组委会':
            this.matchAboutContent = this.dataList.committee
            break;
          case '专家委员会':
            this.matchAboutContent = this.dataList.committeeExpert
            break;
          case '大赛组委会联系方式':
            this.matchAboutContent = this.dataList.committeeConnect
            break;
          case '参赛对象':
            this.matchAboutContent = this.dataList.joinObject
            break;
          case '资料下载':
            this.matchAboutContent = '资料下载'
            break;
          case '奖项设置':
            this.matchAboutContent = this.dataList.awardSet
            break;
          default:
            break;
        }
      },
      gotoWork(row) {
        this.$router.push({
          path: "/worksInfo",
          query: {
            id: row.id
          }
        });
      },
      getDistinctionItem() {
        getDistinctionItemByMatchId({
          limit: 8,
          matchId: Session.get("matchID")
        }).then(res => {
          console.log(res);
          this.machList = res.data.data
        })
      },
      gotoMachList() {
        this.$router.push({
          path: "/more",
          query: {}
        });
      },
      carousel(name, arr, perPage) {
        let num = Math.ceil(arr.length / perPage)
        for (let i = 0; i < num; i++) {
          const startIndex = i * perPage;
          const endIndex = Math.min(startIndex + perPage, arr.length);
          this[name].push({
            content: arr.slice(startIndex, endIndex)
          })
        }
      }
    },
  };

</script>

<style scoped>
  /deep/ .el-carousel {
    height: 530px !important;
  }

  /deep/.el-carousel__container {
    height: 530px !important;
  }

  /deep/.el-carousel__item {
    height: 530px !important;
  }

  /deep/ .el-carousel__button {
    width: var(--width) !important;
    max-width: 80px !important;
  }

  /deep/ .el-carousel__indicators {
    display: flex;
  }

  #slideBox,
  .swiper-container {
    height: 42.7vh !important;
  }

  .swiper-slide>img {
    height: 42.7vh !important;
  }

  /deep/.swiper-slide {
    height: 42.7vh !important;
  }


  .banner .slideBox .bd img {
    width: 100%;
    display: block;
    height: 42.7vh;
  }

  .banner {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    margin-top: 100px;
    height: 42.7vh;
  }

  .banner .slideBox {
    width: 100%;
    overflow: hidden;
    position: relative;
  }

  .banner .slideBox .bd {
    position: relative;
    height: 100%;
    z-index: 0;
  }

  .banner .slideBox .bd ul {
    width: 100%;
    margin: 0;
  }

  .banner .slideBox .bd li {
    zoom: 1;
    vertical-align: middle;
  }

  .tabBox {
    display: flex;
    align-content: center;
    justify-content: center;
    margin: 80px 0;
  }

  .tabBox .tabItemText {
    font-size: 40px;
  }

  .tabBox .tabItem {
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    width: 380px;
    height: 180px;
    background-image: url('../assets/Group1.png');
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    cursor: pointer;
    color: #4F90FD;
    background-size: cover;
  }

  .tabItem:hover {
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    width: 380px;
    height: 180px;
    background-image: url('../assets/Group.png');
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    background-size: cover;
  }

  .tabBox .tabItemChack {
    text-align: center;
    margin-right: 30px;
    width: 380px;
    height: 180px;
    background-image: url('../assets/Group.png');
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    cursor: pointer;
    background-size: cover;
  }

  .bd ul {
    padding: 0;
  }

  p.introbro {
    padding-top: 108px;
    margin-top: -108px;
    /* z-index: 99999;
      position: absolute;
     left: 50%;
      transform: translateX(-50%); */
  }

  .news p:hover {
    color: #315efb;
  }

  .comp_related {
    margin-top: 80px;
  }

  .comp_related .content {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 30px;
  }

  .comp_related .contentLeft {
    width: 300px;
    height: 580px;
    background: #FFFFFF;
    border-radius: 14px 14px 14px 14px;
    font-size: 20px;
    color: #666666;
    padding: 50px 0;
    display: flex;
    flex-direction: column;
    margin-right: 30px;
    font-family: fantasy;
    font-weight: bold;
  }

  .comp_related .contentLeft .item {
    display: flex;
    align-items: center;
    padding: 10px 23px;
    cursor: pointer;
  }

  .nocheckitemryj:hover {
    color: #4F90FD;
  }

  .comp_related .contentLeft .itemChack {
    background: linear-gradient(90deg, #4F90FD 0%, rgba(255, 255, 255, 0.1) 100%);
    color: #333333;
  }

  .comp_related .contentLeft img {
    width: 60px;
    height: 60px;
    margin-right: 11px;
  }

  .comp_related .contentRight {
    width: 870px;
    height: 580px;
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 14px 14px 14px 14px;
    padding: 40px;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    overflow: auto;
  }

  .comp_related .content .imgbg {
    width: 310px;
    height: 610px;
  }

  .comp_related_title {
    background: url(http://jlcareer.match.posedu.cn/assets/addons/cms/img/ctitle_03_dark.png) center no-repeat;
  }

  .EventSchedule {
    margin-bottom: 50px;
  }

  .cr_l img,
  .cr_r img {
    padding-right: 11px;
  }

  .sect_title {
    padding-bottom: 40px;
    height: 140px;
  }

  .cr_title {
    font-size: 22px;
    line-height: 50px;
    padding-left: 0px;
  }

  .cr_det {
    padding-left: 58px;
    line-height: 18px;
  }

  .sche_arrange_title {
    background: url(http://jlcareer.match.posedu.cn/assets/addons/cms/img/ctitle_04.png) center no-repeat;
  }

  /deep/ .el-steps.container.computer.el-steps--horizontal {
    margin-top: 38px;
  }

  .sche_arrange_sect>ul,
  .sche_arrange_sect>ul>li {
    height: 800px;
  }

  .sche_arrange_sect>ul>li {
    border-bottom: 3px solid #0e3e86;
  }

  .competition_news_sect li,
  .sche_arrange_sect>ul>li {
    float: left;
    width: 33.3%;
    box-sizing: border-box;
    border-right: 1px solid #ececec;
  }

  .competition_news_sect .cn_top,
  .sche_arrange_sect .cn_top {
    background: #f1f1f1;
    font-family: "Arial";
    color: #999;
    text-indent: 30px;
  }

  p.cr_det a {
    width: 100%;
    margin-bottom: 6px;
  }

  a {
    color: #00baff !important;
  }

  .competition_news_sect .cn_top .cn_year,
  .sche_arrange_sect .cn_top .cn_year {
    display: block;
    padding-top: 15px;
  }

  .fsize18 {
    font-size: 18px;
  }

  .competition_news_sect .cn_top .cn_date,
  .sche_arrange_sect .cn_top .cn_date {
    font-size: 50px;
    line-height: 68px;
    display: block;
  }

  .sche_arrange_sect>ul>li .sa_explain {
    margin: 50px 30px 0;
    line-height: 24px;
  }

  ul li {
    list-style: none;
  }

  .swiper-container {
    position: relative;
    width: 100%;
    /* height: 686px; */
    background: #fff;
  }

  .swiper-container .swiper-slide {
    width: 100%;
    line-height: 200px;
    /* background: yellowgreen; */
    color: #000;
    font-size: 16px;
    text-align: center;
    width: 100%;
    height: 0;
    position: relative;
    padding-top: 37%;
  }

  /deep/ .el-carousel__indicator.is-active button {
    width: 80px;
    height: 8px;
    background: #4F90FD;
  }

  /deep/ .el-carousel__button {
    width: 80px;
    height: 8px;
    background: #DDDDDD;
  }

  /deep/ .el-carousel__item {
    background-color: rgba(0, 0, 0, 0) !important;
    display: flex;
    justify-content: center;
  }

  .homehot {
    text-align: center;
  }

  .homehot .title {
    font-weight: 600;
    font-size: 40px;
    color: #333333;
  }

  .homehot .mall {
    font-weight: 400;
    font-size: 18px;
    color: #4F90FD;
    line-height: 18px;
    margin: 22px 0 40px;
    cursor: pointer;
  }

  .homehot .carBox {
    width: 1200px;
    display: flex;
    display: grid;
    grid-template-columns: auto auto;
  }

  .homehot .carItem {
    width: 584px;
    height: 140px;
    background: #FFFFFF;
    border-radius: 6px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
  }

  .sstzbox {
    width: 1200px;
    display: flex;
    display: grid;
    grid-template-columns: auto auto;
  }

  .carItem img {
    width: 160px;
    height: 140px;
    border-radius: 6px 0px 0px 6px;
  }

  .carItem:hover img {
    transform: scale(1.1);
    border-radius: 6px;
  }

  .carItem:hover .title {
    color: #4F90FD;
  }

  .carItem:hover .time {
    color: #4F90FD;
  }

  .carItem img {
    transition: all 0.4s;
  }

  .homehot .rightbody {
    padding: 20px 30px;
    text-align: left;
    width: 424px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
  }

  .rightbody .title {
    font-weight: 500;
    font-size: 22px;
    color: #666666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .rightbody .time {
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }

  .rightbody .titleChick {
    font-weight: 500;
    font-size: 22px;
    color: #4F90FD;
  }

  .rightbody .timeChick {
    font-weight: 400;
    font-size: 18px;
    color: #4F90FD;
  }

  .news {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }

  .news>div {
    width: 50%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    letter-spacing: 1px;
  }

  .matchIntroduced .title {
    text-align: center;
    font-size: 26px;
    color: #00baff;
    font-weight: 600;
  }

  .comp_related .title,
  .competingKits .title {
    text-align: center;
    font-weight: 600;
    font-size: 40px;
    color: #333333;
  }

  .expertBox {
    margin: 80px 0 50px;
    text-align: center;
  }

  .expertBox .title {
    font-weight: 600;
    font-size: 40px;
    color: #333333;
    text-align: center;
  }

  .expertBox .mall {
    font-weight: 400;
    font-size: 18px;
    color: #4F90FD;
    line-height: 18px;
    margin: 22px 0 40px;
    cursor: pointer;
  }

  .expertBox .expertContent {
    width: 1230px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
  }

  .expertContent .itemBox {
    flex-basis: 33.3%;
  }

  .expertContent .item {
    width: 380px;
    height: 430px;
    border-radius: 8px 8px 8px 8px;
    margin: 0 15px 30px;
    position: relative;
  }

  .expertContent .board {
    width: 100%;
    background-color: rgba(79, 144, 253, 0.8);
    border-radius: 0 0 8px 8px;
    position: absolute;
    bottom: 0;
    padding: 20px;
  }

  .expertContent .board:hover {
    width: 100%;
    height: 100%;
    background-color: rgba(79, 144, 253, 0.8);
    border-radius: 8px 8px 8px 8px;
    padding: 60px 20px 69px 20px;
    overflow: auto;
    scrollbar-width: none;
  }

  .expertContent .board:hover::-webkit-scrollbar {
    display: none;
    /* 对于Chrome, Safari和Opera */
  }

  .expertContent .board .text1 {
    font-weight: 600;
    font-size: 22px;
    color: #FFFFFF;
  }

  .expertContent .board .text2 {
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
  }

  .expertContent .board .text3 {
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
  }

  .carMach {
    width: 100%;
    background: #FFFFFF;
    padding: 40px 0;
  }

  .carMach .carBoxMach {
    width: 90%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    margin: 40px 5%;
    justify-content: center;
  }

  .carMach .title {
    font-weight: 600;
    font-size: 40px;
    color: #333333;
    text-align: center;
    margin-bottom: 40px;
  }

  .carMach .more {
    font-weight: 400;
    font-size: 18px;
    color: #4F90FD;
    line-height: 18px;
    margin: 22px 0 40px;
    cursor: pointer;
    text-align: center;
  }

  .carBoxMach .carBoxMachItem {
    width: 324px;
    margin: 10px 3%;
    border-radius: 14px;
    background-color: #fff;
    box-shadow: 4px 4px 8px #eee;
  }

  .carBoxMachItem img {
    width: 324px;
    height: 160px;
    border-radius: 14px 14px 0 0;

  }

  .carouselheight {
    height: 530px !important;
  }

  .ParticipatingSchools {
    background-image: url('../assets/schoolBg.png');
    height: 702px;
    margin: 60px 0 -30px;
    padding-top: 50px;
    background-size: cover;
  }

  .ParticipatingSchools .title {
    font-weight: 600;
    font-size: 40px;
    color: #333333;
    text-align: center;
    margin-bottom: 40px;
  }

  .ParticipatingSchools .carBoxSchool {
    width: 1220px;
    display: flex;
    /* justify-content: space-around; */
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
  }

  .carBoxSchool .carBoxSchoolItem {
    width: 136px;
    height: 80px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px;
  }

  .carBoxSchool .img {
    width: 70px;
    height: 70px;
    /* padding-right: 8px;
  padding-bottom: 8px; */
    margin-top: 0 !important;
  }

  .carBoxSchool :hover {
    margin-top: 5px;
  }

  .EventSchedule {
    min-height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('../assets/marchBg.png');
  }

  .EventSchedule .diamond {
    width: 240px;
    height: 240px;
    border-radius: 14px 14px 14px 14px;
    transform: rotate(45deg);
    margin: 0 50px;
  }

  .EventSchedule .color0 {
    background: #3BDF9B;
  }

  .EventSchedule .color1 {
    background: #4F90FD;
  }

  .EventSchedule .color2 {
    background: #EFB734;
  }

  .EventSchedule .item {
    display: flex;
    align-items: center;
  }

  .EventSchedule .item img {
    width: 29px;
    height: 28px;
    margin: 0 31px
  }

  .EventSchedule .diamondInfo {
    transform: rotate(314deg);
    width: 240px;
    height: 240px;
    text-align: center;
    color: #FFFFFF;
    font-weight: 600;
  }

  .diamondContent {
    font-size: 20px;
    margin-top: 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .diamondContenttext1 {
    font-weight: 400;
    font-size: 18px;
    margin-top: 20px;
  }

  .diamondContenttext2 {
    font-weight: 400;
    font-size: 18px;
  }

  .diamondContenttext3 {
    font-size: 34px;
  }

  .diamondContenttext4 {
    font-size: 36px;
  }

  /deep/ .el-step__description.is-finish,
  /deep/ .el-step__title.is-finish {
    color: #fff !important;
  }

  /deep/ .el-step__head.is-finish {
    border-color: #fff !important;
  }

  .competingKits .swiper-wrapper>div {
    height: 50%;
  }

  #slideBox img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
  }

  /deep/ .el-step__icon-inner {
    display: none;
  }

  /* .EventSchedule.container:hover{
    display: none;
  } */
  .ssjd:hover {
    transform: scale(1.07);
    cursor: pointer;
  }

  .ssjd {
    transition: all 0.4s
  }

  .titleasdas {
    text-align: center;
    font-size: 26px;
    color: #00baff;
    font-weight: 600;
    margin: 15px 0;
  }

  .intro {
    display: none;
    position: absolute;
    top: 48px;
    left: 50%;
    transform: translateX(-50%);
    width: 475px;
    /* width: 60%; */
    border: 1px solid #fff;
    background-color: #fff;
    padding: 5px;
    max-height: 400px;
    overflow-y: scroll;
    border: 1px solid #ccc;
    z-index: 9999999;
  }

  .el-step__head:hover+.el-step__main .intro,
  .el-step__title:hover+.el-step__description .intro,
  .el-step__main:hover .intro {
    display: block;
    border-radius: 5px;
    box-shadow: 3px 3px 2px #888888;
    cursor: pointer;
  }

  /deep/ .el-step__main:hover .intro {
    display: block;
    border-radius: 5px;
    box-shadow: 3px 3px 2px #888888;
    cursor: pointer;
  }

  /deep/ .el-step__main {
    cursor: pointer;
  }

  .intro p {
    font-size: 15px;
    letter-spacing: 1px;
    color: black;
    text-align: initial;
  }

  /deep/ .el-step__title.is-process {
    color: yellow;
  }

  /deep/ .is-process .el-step__icon.is-text {
    border-color: yellow !important;
    background-color: yellow;
  }

  /deep/ .el-step__description.is-process {
    color: yellow !important;
  }

  /deep/ .el-step__line {
    background-color: #fff;
  }

  .schoolP {
    max-height: 600px;
    overflow-y: scroll;
    padding: 9px !important;
  }

  p.introbro {
    font-size: 14px;
  }

  /deep/ .el-step__description.is-wait,
  /deep/ .el-step__title.is-wait {
    color: #fff;
  }

  /deep/ .el-step.is-center .el-step__description {
    padding-top: 46px;
  }

  /deep/ .el-step__title {
    margin-top: -73px;
    font-size: 18px;
  }

  .wrapper {
    display: none;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  video {
    width: 100%;
    height: 81%;
  }

  /deep/ .el-carousel.el-carousel--horizontal.el-carousel--card h2 {
    text-align: center;
    background-color: #fff;
    padding-top: 24px;
    margin-top: -16px;
    padding-bottom: 22px;
    margin-bottom: -10px;
    font-size: 22px;
  }

  .pcmobile {
    display: none;
  }

  .flowBox {
    background-image: url('../assets/dslcBackground1.png');
    background-size: cover;
    color: #FFFFFF;
    text-align: center;
    padding: 80px 0 62px;
  }

  .flowTitle {
    font-weight: 600;
    font-size: 40px;
    color: #FFFFFF;
  }

  @media screen and (max-width: 1600px) {
    .comp_related .contentLeft {
      width: 300px;
      height: 580px;
      background: #FFFFFF;
      border-radius: 14px 14px 14px 14px;
      font-size: 16px;
      color: #666666;
      padding: 50px 0;
      display: flex;
      flex-direction: column;
      margin-right: 30px;
      font-family: fantasy;
      font-weight: bold;
    }

    .comp_related .contentLeft .item {
      display: flex;
      align-items: center;
      padding: 10px 15px;
      cursor: pointer;
    }

    .expertBox {
      margin: 80px 0 50px;
      text-align: center;
    }

    .expertBox .title {
      font-weight: 600;
      font-size: 40px;
      color: #333333;
      text-align: center;
    }

    .expertBox .mall {
      font-weight: 400;
      font-size: 18px;
      color: #4F90FD;
      line-height: 18px;
      margin: 22px 0 40px;
      cursor: pointer;
    }

    .expertBox .expertContent {
      width: 1193.1px;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      align-content: flex-start;
    }

    .expertContent .itemBox {
      flex-basis: 33.3%;
    }

    .expertContent .item {
      width: 266px;
      height: 301px;
      border-radius: 8px 8px 8px 8px;
      margin: 0 14.55px 29.1px;
      position: relative;
    }

    .expertContent .board {
      width: 100%;
      background-color: rgba(79, 144, 253, 0.8);
      border-radius: 0 0 8px 8px;
      position: absolute;
      bottom: 0;
      padding: 19.4px;
    }

    .expertContent .board:hover {
      width: 100%;
      height: 100%;
      background-color: rgba(79, 144, 253, 0.8);
      border-radius: 8px 8px 8px 8px;
      padding: 58.2px 19.4px 66.93px 19.4px;
      overflow: auto;
      scrollbar-width: none;
    }

    .expertContent .board:hover::-webkit-scrollbar {
      display: none;
      /* 对于Chrome, Safari和Opera */
    }

    .expertContent .board .text1 {
      font-weight: 600;
      font-size: 18px;
      color: #FFFFFF;
    }

    .expertContent .board .text2 {
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
    }

    .expertContent .board .text3 {
      font-weight: 500;
      font-size: 12px;
      color: #FFFFFF;
    }
  }

  @media screen and (max-width: 1400px) {
    .tabBox {
      display: flex;
      align-content: center;
      justify-content: center;
      margin: 80px 0;
    }

    .tabBox .tabItemText {
      font-size: 30px;
    }

    .tabBox .tabItem {
      text-align: center;
      margin-left: 10px;
      margin-right: 10px;
      width: 266px;
      height: 126px;
      background-image: url('../assets/Group1.png');
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      cursor: pointer;
      color: #4F90FD;
      background-size: cover;
    }

    .tabItem:hover {
      text-align: center;
      margin-left: 10px;
      margin-right: 10px;
      width: 266px;
      height: 126px;
      background-image: url('../assets/Group.png');
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      cursor: pointer;
      color: #fff;
      background-size: cover;
    }

    .tabBox .tabItemChack {
      text-align: center;
      margin-left: 10px;
      margin-right: 10px;
      width: 266px;
      height: 126px;
      background-image: url('../assets/Group.png');
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      cursor: pointer;
      background-size: cover;
    }

    .EventSchedule {
      min-height: 500px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url('../assets/marchBg.png');
      background-size: cover;
    }

    .EventSchedule .diamond {
      width: 168px;
      height: 168px;
      border-radius: 14px 14px 14px 14px;
      transform: rotate(45deg);
      margin: 0 50px;
    }

    .EventSchedule .color0 {
      background: #3BDF9B;
    }

    .EventSchedule .color1 {
      background: #4F90FD;
    }

    .EventSchedule .color2 {
      background: #EFB734;
    }

    .EventSchedule .item {
      display: flex;
      align-items: center;
    }

    .EventSchedule .item img {
      width: 29px;
      height: 28px;
      margin: 0 31px
    }

    .EventSchedule .diamondInfo {
      transform: rotate(314deg);
      width: 168px;
      height: 168px;
      text-align: center;
      color: #FFFFFF;
      font-weight: 600;
    }

    .diamondContent {
      font-size: 15px;
      margin-top: 8px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .diamondContenttext1 {
      font-weight: 400;
      font-size: 12px;
      margin-top: 12px;
    }

    .diamondContenttext2 {
      font-weight: 400;
      font-size: 12px;
    }

    .diamondContenttext3 {
      font-size: 18px;
    }

    .diamondContenttext4 {
      font-size: 20px;
    }

    .comp_related .contentLeft {
      width: 240px;
      height: 406px;
      background: #FFFFFF;
      border-radius: 14px 14px 14px 14px;
      font-size: 16px;
      color: #666666;
      padding: 30px 0;
      display: flex;
      flex-direction: column;
      margin-right: 20px;
      font-family: fantasy;
      font-weight: bold;
    }

    .comp_related .contentLeft p {
      margin-bottom: 5px !important;
    }

    .comp_related .contentLeft .item {
      display: flex;
      align-items: center;
      padding: 10px 20px;
      cursor: pointer;
    }

    .nocheckitemryj:hover {
      color: #4F90FD;
    }

    .comp_related .contentLeft .itemChack {
      background: linear-gradient(90deg, #4F90FD 0%, rgba(255, 255, 255, 0.1) 100%);
      color: #333333;

    }

    .comp_related .contentLeft img {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }

    .comp_related .contentRight {
      width: 609px;
      height: 406px;
      background-color: rgba(255, 255, 255, 0.6);
      border-radius: 14px 14px 14px 14px;
      padding: 40px;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      overflow: auto;
    }

    .comp_related .content .imgbg {
      width: 217px;
      height: 427px;
    }

    .carouselheight {
      height: 410px !important;
    }

    .ParticipatingSchools {
      background-image: url('../assets/schoolBg.png');
      height: 702px;
      margin: 60px 0 -30px;
      padding-top: 50px;
    }

    .ParticipatingSchools .title {
      font-weight: 600;
      font-size: 40px;
      color: #333333;
      text-align: center;
      margin-bottom: 40px;
    }

    .ParticipatingSchools .carBoxSchool {
      width: 900px;
      display: flex;
      /* justify-content: space-around; */
      flex-wrap: wrap;
      align-items: flex-start;
      align-content: flex-start;
    }

    .carBoxSchool .carBoxSchoolItem {
      width: 95.2px;
      height: 56px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 8px;
    }

    .carBoxSchool .img {
      width: 49px;
      height: 49px;
      /* padding-right: 8px;
    padding-bottom: 8px; */
      margin-top: 0 !important;
    }

    .carBoxSchool :hover {
      margin-top: 5px;
    }

    .sstzbox {
      width: 840px;
      display: flex;
      display: grid;
      grid-template-columns: auto auto;
    }

    .carItem img {
      width: 112px;
      height: 98px;
      border-radius: 6px 0px 0px 6px;
    }

    .carItem:hover img {
      transform: scale(1.1);
      border-radius: 6px;
    }

    .carItem:hover .title {
      color: #4F90FD;
    }

    .carItem:hover .time {
      color: #4F90FD;
    }

    .carItem img {
      transition: all 0.4s;
    }

    .homehot .carItem {
      width: 408.8px;
      height: 98px;
      background: #FFFFFF;
      border-radius: 6px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 8px;
    }

    .homehot .rightbody {
      padding: 20px 30px;
      text-align: left;
      width: 296.8px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      cursor: pointer;
    }

    .rightbody .title {
      font-weight: 500;
      font-size: 18px;
      color: #666666;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .rightbody .time {
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }

    .rightbody .titleChick {
      font-weight: 500;
      font-size: 18px;
      color: #4F90FD;
    }

    .rightbody .timeChick {
      font-weight: 400;
      font-size: 14px;
      color: #4F90FD;
    }
  }

  @media screen and (max-width: 1100px) {
    .comp_related .contentLeft {
      width: 240px;
      height: 406px;
      background: #FFFFFF;
      border-radius: 14px 14px 14px 14px;
      font-size: 12px;
      color: #666666;
      padding: 30px 0;
      display: flex;
      flex-direction: column;
      margin-right: 20px;
      font-family: fantasy;
      font-weight: bold;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue